// src/Config.js

const apiURL = 'https://backend.srihemaruba.in';
// const apiURL="http://localhost:5005"

export default apiURL;